import { Alert, Snackbar } from "@mui/material";
import React from "react";

const KeywordClickSnackBar = ({ open, setOpen }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      onClose={() => setOpen(false)}
    >
      <Alert
        onClose={() => setOpen(false)}
        severity="warning"
        variant="filled"
        sx={{ width: "100%" }}
      >
        The current list has been already filtered with this interest!
      </Alert>
    </Snackbar>
  );
};

export default KeywordClickSnackBar;
